import request from "./core";

interface getPhraseResponse {
  content: string;
}

export interface Banner {
  bannerId: number;
  category: string;
  imageUrl: string;
  linkUrl: string;
}

export const getBanners = async (): Promise<Banner[]> => {
  return await request.get<Banner[]>("/banners");
};

export const getPhrase = () => {
  return request.get<getPhraseResponse>(`/phrase`);
};

export const getTabs = () => {
  return request.get<{ availableCount: number }>("/tabs");
};
